@if (isViewOnly) {
    <div
        class="design-building-block-sign-up-overlay"
        style="height: 100% !important"></div>
}

<div class="padding-24">
    <lib-radio-card-group (cardClicked)="ItemSelected($event)">
        <lib-radio-card
            [value]="AllTeachersID">
            <ng-container radioCardPrefix>
                    <div
                        [ngClass]="{'sb-avatar-medium': isMobile, 'sb-avatar-large': !isMobile }"
                        class="sb-avatar scss-sign-up-avatar d-flex align-items-center justify-content-center">
                        <lib-icon
                            class="scss-sign-up-avatar-icon-colour"
                            [icon]="Icon.Common.ArrowForward"
                            [size]="isMobile ? IconSize.Medium : IconSize.ExtraLarge"></lib-icon>
                    </div>
            </ng-container>
            <ng-container title i18n="@@CommonAllTeachersTitle">
                All #Teachers#
            </ng-container>
            <ng-container text i18n="@@CommonSignUpAllTeachersOptionSupportingText">Skip this step, and choose a date and time first.</ng-container>
        </lib-radio-card>
        @for (item of visibleTeachers | slice: 0 : visibleItemsCount; track item.ID) {
            <lib-radio-card
                [value]="item.ID">
                <ng-container radioCardPrefix>
                    <lib-profile-image
                        class="sb-sign-up-profile-item-color-override"
                        [imageURL]="item | method: GetProfileHeadshotURL"
                        [hasImageToShow]="item.HasProfilePicture"
                        [displayItem]="item"
                        [size]="isMobile? ProfileImageSize.Medium : ProfileImageSize.Large">
                    </lib-profile-image>
                </ng-container>
                <ng-container title>
                    {{item.Name}}
                </ng-container>
                <ng-container tagsTitle>
                    @if (item.SpokenLanguages.length > 0) {
                        <ng-container i18n="@@CommonSpeaksColon">Speaks:</ng-container>
                    }
                </ng-container>
                <ng-container tags>
                    @for (language of item.SpokenLanguages | slice: 0 : this.maxLabelsPerRow - 1; track language) {
                        <lib-status-label
                            [kind]="StatusKind.Light">
                            <ng-container label>
                                {{language.NativeName }}
                            </ng-container>
                        </lib-status-label>
                    }
                    @if (item.SpokenLanguages.length > this.maxLabelsPerRow) {
                        <lib-status-label
                            toolTipPosition="below"
                            [toolTipText]="item.SpokenLanguages | method: GetMoreLanguagesTooltipText"
                            [kind]="StatusKind.Neutral">
                            <ng-container label i18n="@@CommonPlusXMore">
                                +{{(item.SpokenLanguages.length - (this.maxLabelsPerRow - 1))}} more
                            </ng-container>
                        </lib-status-label>
                    }
                </ng-container>
                <ng-container text>
                    @if (item.BiographyBody) {
                        <p #bio>
                            {{ item.BiographyBody }}
                        </p>
                        <lib-expandable-text
                            [targetText]="bio"
                            [numberOfLines]="2"></lib-expandable-text>
                    }
                </ng-container>
            </lib-radio-card>
        }
    </lib-radio-card-group>
    @if (visibleItemsCount < totalTeachersCount) {
        <div class="d-flex justify-content-center">
            <lib-button
                [prefixIcon]="Icon.Common.ExpandMore"
                [kind]="ButtonKind.Link"
                (clicked)="ShowMoreItems()">
                <ng-container
                    label
                    i18n="@@CommonShowMoreButton">
                    Show More
                </ng-container>
            </lib-button>
        </div>
    }
</div>
<mat-divider></mat-divider>
<lib-submission-bar [kind]="SubmissionBarKind.WidgetStepper">
    <lib-button
    [role]="ButtonRole.Primary"
        [loading]="clicked"
        [isViewOnly]="isViewOnly"
        [size]="ButtonSize.Large"
        (clicked)="Signup()">
        <!-- @if (!itemSelected) { -->
        <ng-container
            label
            i18n="@@CommonSkipButton">
            Skip
        </ng-container>
        <!-- } @else {
            <ng-container
                label
                i18n="@@CommonNextButton">
                Next
            </ng-container>
        } -->
    </lib-button>
    <lib-button
    [role]="ButtonRole.Secondary"
        [disabled]="clicked"
        [isViewOnly]="isViewOnly"
        [kind]="ButtonKind.NeutralSecondary"
        [size]="ButtonSize.Large"
        (clicked)="PreviousClicked()">
        <ng-container
            label
            i18n="@@CommonPreviousButton">
            Previous
        </ng-container>
    </lib-button>
</lib-submission-bar>
